import { render, staticRenderFns } from "./PersonalityTraitCompactCard.vue?vue&type=template&id=6b096ce2"
import script from "./PersonalityTraitCompactCard.vue?vue&type=script&lang=js"
export * from "./PersonalityTraitCompactCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports